import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { kenoBetStore } from '../../store/kenoBetStore';
import NumpadNumbers from './numpadNumbers';
import CloseNumpadButton from './closeNumpadButton';
import OkNumpadButton from './okNumpadButton';
import ChangeAmountButtons from './changeAmountButtons';
import SelectedQuickBets from './selectedQuickBets';
import { userInfoStore } from '../../store/userInfoStore';
import { numpadValueValidation } from '../../core/helpers/numpadValueValidation';

const Numpad = observer(() => {
  const { isOpenNumpad, setIsOpenNumpad } = kenoBetStore;
  const { setBetAmount, betAmount, limits } = userInfoStore;
  const ref = useRef();

  const validateNumpadValue = useCallback(
    () => numpadValueValidation(betAmount, limits, setBetAmount),
    [betAmount, setBetAmount, limits]
  );

  const handleClick = useCallback(
    (e) => {
      // @ts-ignore
      if (!(ref.current && ref.current.contains(e.target))) {
        setIsOpenNumpad(false);
        validateNumpadValue();
      }
    },
    [setIsOpenNumpad, validateNumpadValue]
  );

  useEffect(() => {
    if (isOpenNumpad) {
      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('click', handleClick);
      };
    }
    return null;
  }, [handleClick, isOpenNumpad]);
  return (
    <div className={`numpad-wrapper ${isOpenNumpad ? 'active' : ''}`} ref={ref}>
      <div className='numpad-wrapper-inner'>
        <SelectedQuickBets />
        <ChangeAmountButtons />
        <NumpadNumbers />
        <div className='numpad-btn-block'>
          <CloseNumpadButton validateNumpadValue={validateNumpadValue} />
          <OkNumpadButton validateNumpadValue={validateNumpadValue} />
        </div>
      </div>
    </div>
  );
});
export default Numpad;
